// extracted by mini-css-extract-plugin
export default {"container":"StatementSuccess_container__kstqe"};